import React, { useState, useRef, useEffect } from 'react';
import styles from './Select.module.css';

const Select = ({
    options = [],
    value,
    onChange,
    placeholder = 'Выберите...',
    label,
    error,
    disabled = false,
    variant = 'default',
    size = 'md',
    className = '',
    id,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);
    const containerRef = useRef(null);

    // Закрытие при клике вне компонента
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (option) => {
        onChange(option.value);
        setIsOpen(false);
    };

    const selectedOption = options.find(opt => opt.value === value);

    return (
        <div className={`${styles.selectContainer} ${className}`} ref={containerRef}>
            {label && (
                <label className={styles.label} htmlFor={id}>
                    {label}
                </label>
            )}
            <div
                className={`${styles.select} ${styles[variant]} ${styles[size]} ${isOpen ? styles.open : ''} ${error ? styles.error : ''} ${disabled ? styles.disabled : ''}`}
                onClick={() => !disabled && setIsOpen(!isOpen)}
                ref={selectRef}
                tabIndex={disabled ? -1 : 0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        !disabled && setIsOpen(!isOpen);
                    }
                    if (e.key === 'Escape') {
                        setIsOpen(false);
                    }
                }}
                role="combobox"
                aria-expanded={isOpen}
                aria-haspopup="listbox"
                aria-labelledby={label ? `label-${id}` : undefined}
            >
                <span className={styles.value}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <span className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ''}`}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
            </div>

            {isOpen && (
                <ul className={styles.dropdown} role="listbox">
                    {options.length === 0 ? (
                        <li className={styles.empty}>Нет вариантов</li>
                    ) : (
                        options.map(option => (
                            <li
                                key={option.value}
                                className={`${styles.option} ${value === option.value ? styles.selected : ''}`}
                                onClick={() => handleSelect(option)}
                                role="option"
                                aria-selected={value === option.value}
                            >
                                {option.label}
                            </li>
                        ))
                    )}
                </ul>
            )}

            {error && (
                <span className={styles.errorMessage}>{error}</span>
            )}
        </div>
    );
};

export default Select;
